import { useRef } from "react";
import useResultsWorkspaceBootstrap from "./useResultsWorkspaceBootstrap.js";
import useResultsWorkspacePopoverState from "./useResultsWorkspacePopoverState.js";
import useResultsWorkspaceSelectionState from "./useResultsWorkspaceSelectionState.js";
import { createResultsWorkspaceStore } from "../utils/resultsWorkspaceStore.js";

const EMPTY_MAP_CONTROLLER = {
  clearHighlight() {},
  highlightClient() {},
  highlightRouteSegment() {},
  restoreView() {
    return false;
  },
  toggleRouteNumber() {
    return false;
  },
  zoomToClient() {
    return false;
  },
};

export default function useResultsWorkspaceState({
  buildFleetCards = null,
  detailViewState,
  initialResultsData = null,
}) {
  const workspaceStoreRef = useRef(null);
  if (!workspaceStoreRef.current) {
    workspaceStoreRef.current = createResultsWorkspaceStore();
  }

  const workspaceStore = workspaceStoreRef.current;
  const { stateRef } = workspaceStore;
  const mapStateRef = useRef(EMPTY_MAP_CONTROLLER);
  const interactionsRef = useRef({ assignmentCard: null, chrome: null });
  const {
    handleClientSelection,
    handleMapRenderMetaChange,
    mapRenderMeta,
    renderAssignmentCards,
    renderCurrentSelection,
    resetMapRenderMeta,
    selectionRequest,
    setWorkspaceSelectionState,
    syncWorkspaceUi,
    workspaceUi,
  } = useResultsWorkspaceSelectionState({
    buildFleetCards,
    interactionsRef,
    workspaceStore,
  });
  const {
    closeReassignmentPopover,
    reassignmentPopover,
    toggleReassignmentPopover,
  } = useResultsWorkspacePopoverState({
    renderAssignmentCards,
    workspaceStore,
  });
  const { workspaceElements } = useResultsWorkspaceBootstrap({
    detailViewState,
    initialResultsData,
    resetMapRenderMeta,
    setWorkspaceSelectionState,
    syncWorkspaceUi,
    workspaceStore,
  });

  const setMapController = (controller) => {
    mapStateRef.current = controller || EMPTY_MAP_CONTROLLER;
  };

  return {
    closeReassignmentPopover,
    handleClientSelection,
    handleMapRenderMetaChange,
    interactionsRef,
    mapStateRef,
    reassignmentPopover,
    renderAssignmentCards,
    renderCurrentSelection,
    selectionRequest,
    setMapController,
    stateRef,
    syncWorkspaceUi,
    toggleReassignmentPopover,
    mapRenderMeta,
    workspaceStore,
    workspaceElements,
    workspaceUi,
  };
}